import { ListItem } from '../store/typeahead/types';

/** "All" entry of a multi-select dropdown: present in a selection, the field is sent empty. */
export const ALL_SELECTION_ID = -1;

/** "All" picked last replaces the selection; any other pick drops "All"; nothing left = "All". */
export const normalizeAllSelection = (ids: number[]): number[] => {
  if (ids.slice(-1)[0] === ALL_SELECTION_ID) return [ALL_SELECTION_ID];

  const withoutAll = withoutAllOption(ids);

  return withoutAll.length ? withoutAll : [ALL_SELECTION_ID];
};

/** The items of a dropdown, an "All" entry first. */
export const withAllOption = (
  items: ListItem[],
  allLabel: string,
): ListItem[] => [
  { id: ALL_SELECTION_ID, name: allLabel, value: '' },
  ...items,
];

/** The selection as an API filter: an empty list reads as "all". */
export const withoutAllOption = (ids: number[]): number[] =>
  ids.filter((id) => id !== ALL_SELECTION_ID);
